import { Component } from 'react'
import { connect } from 'react-redux';
import { clearCompleteState } from '../actions/generalActions'

class ClearCachePage extends Component {

  componentDidMount() {
    this.props.clearCompleteState();
  }

  render() {
    return null;
  }
}

ClearCachePage.propTypes = {
}

function mapStateToProps(state) {
  return {
  }
}

export default connect(mapStateToProps, {
  clearCompleteState
})(ClearCachePage)



// WEBPACK FOOTER //
// src/pages/ClearCachePage.jsx